import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DebugService {
  debugVisible = signal<boolean>(false);
  debugWarningArray = [
    'Careful, here be dragons',
    'Not for the faint of heart',
    'I hope you know what you’re doing',
    'Welcome to the Danger Zone',
    'Abandon all hope, ye who enter here',
    'Debug mode: where code goes to cry',
    'You break it, you fix it',
    'Here lies the path of infinite console logs',
    'Warning: sanity not included',
    'It’s not broken… until it is',
  ];

  selectedWarning = signal<string>(this.debugWarningArray[Math.floor(Math.random() * this.debugWarningArray.length)]);

  debugMode = signal<boolean>(false);

  constructor() {
   }

  toggleDebugMode() {
    this.debugMode.set(!this.debugMode());
  }

  setDebugMode(value: boolean) {
    this.debugMode.set(value);
  }

  toggleDebugVisible() {
    this.debugVisible.set(!this.debugVisible());
  }
}
